import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { MessageBox } from "./MessageBox";
export const INPUT_MSG_BOX = 'input-msg-box';
export const Input = /*#__PURE__*/ forwardRef(({ className, 'data-testid': dataTestId, errors, label, ...props }, ref)=>{
    const baseStyle = 'mb-2 mt-0 w-full rounded-md border border-navy-20 bg-white px-3 py-2 text-[15px] text-navy shadow-sm outline-none placeholder:text-navy-50 focus:border-primary focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:bg-navy-5 disabled:text-navy-50';
    const labelClass = 'block font-medium mb-2 text-sm text-gray-700 mt-0';
    const messageBoxTestId = dataTestId ?? 'default';
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            !!label && /*#__PURE__*/ _jsx("label", {
                className: labelClass,
                children: label
            }),
            /*#__PURE__*/ _jsx("input", {
                ref: ref,
                className: twMerge(baseStyle, className),
                "data-testid": dataTestId,
                ...props
            }),
            !!errors && errors.message && /*#__PURE__*/ _jsx(MessageBox, {
                className: "px-4 py-2 mb-6",
                "data-testid": messageBoxTestId + '_' + INPUT_MSG_BOX,
                message: errors.message,
                type: "error"
            })
        ]
    });
});
